<div style="width: 100%" [class.disabled]="disabled">
  <div *ngFor="let document of documents; let idx = index" style="margin-bottom: 1vh">
    <div class="documents">
      <a [attr.href]="document.uri" target="_blank" style="word-break: break-word"> {{ document.displayName }} </a>
      <div style="flex-grow: 1"><!--spacer --></div>
      <div>
        <markant-icon (click)="removeFile(idx)" src="./assets/svg/m_trash.svg" class="markant-icon" [class.disabled]="disabled">delete</markant-icon>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>

  <div class="documentUploadWrapper">
    <app-continuous-action [sticky]="false"></app-continuous-action>
    <app-dropzone
      [message]="'Hier kannst Du Deine Dokumente hochladen'"
      accept=".pdf"
      [maxFileSize]="maxFileSize"
      (fileListChange)="handleNewFiles($event)"
      [disabled]="disabled"
    ></app-dropzone>
  </div>
</div>
